import { useEffect, useRef } from 'react';
// Assure-toi que le chemin d'import est correct selon ton architecture
import { initP5Trajet } from '../scripts/p5js-trajet.js'; 

export default function ProjectP5Trajet() {
    const canvasContainerRef = useRef(null);

    useEffect(() => {
        let cleanup = null;

        // Si le conteneur est prêt, on injecte l'instance p5.js
        if (canvasContainerRef.current) {
            cleanup = initP5Trajet(canvasContainerRef.current);
        }

        // Nettoyage automatique au démontage du composant
        return () => {
            if (cleanup) cleanup();
        };
    }, []);

    return (
        <div className="project-page">
            <main className="project-main">
                {/* Le canvas sera généré à l'intérieur de cette div.
                    J'ai ajouté des styles inline pour centrer le canvas,
                    remplaçant ainsi la manipulation DOM que tu faisais dans le setup() p5 */}
                <div 
                    id="p5-canvas" 
                    ref={canvasContainerRef}
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                ></div>

                <div className="project-content">
                    <h1>Trajectoire Souris – Effet interactif en p5.js</h1>
                    <p className="project-desc">
                        Un effet de traînée discret qui suit le curseur avec un fade
                        subtil et une opacité variable. Chaque cercle laisse une
                        trace légère qui disparaît progressivement, créant une
                        animation fluide et dynamique.
                    </p>

                    <div className="project-tech">
                        <h3>Techno</h3>
                        <ul>
                            <li>p5.js</li>
                            <li>Array pour l’historique des positions (trail)</li>
                            <li>Fade du background via alpha</li>
                            <li>Effets d’opacité et taille dynamiques</li>
                        </ul>
                    </div>
                </div>
            </main>
        </div>
    );
}